import { Vector2Tuple, Vector3 } from 'three';

import { NavMeshQuery } from '@spazious/dollhouse-navmesh';

const _target = new Vector3();
const _start = new Vector3();
export const resizePolygonInNavMesh = (
  startCorners: Vector2Tuple[],
  targetCorners: Vector2Tuple[],
  navMeshQuery: NavMeshQuery
): { isTargetWithinNavMesh: boolean; corners: Vector2Tuple[] } => {
  // for each corner, find distance factor(t) to target position
  //  ignore the ones where no change in poistion
  // and, get the least distance factor
  const { t: distanceFactor, isTargetWithinNavMesh } = startCorners.reduce(
    (acc, start, idx) => {
      const target = targetCorners[idx];

      _start.set(start[0], 0, start[1]);
      _target.set(target[0], 0, target[1]);
      if (!_start.equals(_target)) {
        const startPoly = navMeshQuery.findNearestPoly(_start);

        const result = navMeshQuery.raycast(startPoly.nearestRef, _start, _target);
        if (result.success && result.t < 1) {
          acc.isTargetWithinNavMesh = false;
          acc.t = Math.min(result.t, acc.t);
        }
      }

      return acc;
    },
    { t: 1, isTargetWithinNavMesh: true }
  );

  // for each corner find the point at distanceFactor in the target direction
  // i.e, actual target point or the point on the navmesh border
  // then based on corner points, calc center and size
  let corners: Vector2Tuple[] = isTargetWithinNavMesh
    ? targetCorners
    : startCorners.map((start, idx) => {
        const target = targetCorners[idx];

        _start.set(start[0], 0, start[1]);
        _target.set(target[0], 0, target[1]);
        if (!_start.equals(_target)) {
          _start.lerp(_target, distanceFactor);
        }
        return [_start.x, _start.z];
      });

  return { isTargetWithinNavMesh, corners };
};
